// src/pages/Account.tsx
import React, { useEffect, useState } from "react";
import { Button, Typography } from "antd";
import { signout } from "../../services/Signout";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import TopBar from "../TopBar/TopBar"; // Import the TopBar component
import "./Account.scss"; // Add any necessary styles for this page
import profile from "../../assets/Profile.png";
import { getPPIreports } from "../../services/getPPI";
import PPITable, { PPIReport } from "../../components/PPITable/PPITable";

const { Title } = Typography;
interface AccountProps {}

const Account: React.FC<AccountProps> = () => {
  const navigate = useNavigate();
  const [ppiReports, setPpiReports] = useState<PPIReport[]>([]);
  const { email } = useUser(); // Get email from context

  const handleLogout = async () => {
    await signout();
    navigate("/signin");
  };

  // useEffect(() => {
  //   console.log("User email in Account component:", email);
  // }, [email]);

  useEffect(() => {
    const fetchReports = async () => {
      const reports = await getPPIreports();
      setPpiReports(reports);
    };
    fetchReports();
  }, []);

  return (
    <div className="account-page">
      <TopBar title="Account" />
      <div className="account-content">
        {email ? (
          <>
            <h1>Account</h1>
            <p>All About You</p>
            <div className="profile-picture">
              <img
                src={profile}
                alt="Profile"
                className="profile-img"
              />
            </div>
            <p className="email">{email}</p>
            <div className="button-group">
              <Button type="primary" className="account-button" onClick={handleLogout}>
                Log Out
              </Button>
              <Button type="primary" className="account-button" href="https://app.pacer.co/#/account" target="_blank">
                Profile
              </Button>
            </div>
            {ppiReports.length > 0 && <PPITable reports={ppiReports} />}
          </>
        ) : (
          <div className="anonymous-account-content">
            <Title level={4} style={{ color: 'white' }}>Enjoying the Demo?</Title>
            <p>
              If you have any specific feedback, we would love to hear from you! Send us an email at <a href="mailto:wyeth@pacer.co">wyeth@pacer.co</a>.
            </p>
            <p>
              Otherwise, we would love for you to sign up for our main product below.
            </p>
            <p>- The Pacer Team</p>
            <Button
              type="primary"
              className="account-button"
              href="https://reports.pacer.co/signin"
              target="_blank"
            >
              Sign Up
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Account;
